import { createSlice } from "@reduxjs/toolkit";
import { getRequest } from "../../../services/apiCaller/cl_index";
import { endpoints } from "../../../api/ApiEndPoints";

const initialState={
    staticContent:''
}


export const bottomMenuSlice=createSlice({
    name:'bottomMenu',
    initialState,
    reducers:{
        setStaticContent:(state,action)=>{
            state.staticContent=action.payload
        }
    }
})

export const {setStaticContent}=bottomMenuSlice.actions;


export const setbottomMenuContent=(brandid)=>(dispatch)=>{
    const url=endpoints.bottomMenuStaticContent+`/${brandid}`;
    getRequest(url).then((res) => {
        if (res?.status === 200) {
          dispatch(setStaticContent(res?.data));
        }else{
          dispatch(setStaticContent([]))
        }
      });
}
export default bottomMenuSlice.reducer;

